export default __webpack_public_path__ + "static/media/file-delete.ff4e0883.png";